import {
  List,
  Datagrid,
  DateField,
  BooleanField,
  ChipField,
  NumberField,
  TextField,
  BooleanInput,
  SelectInput,
  Edit,
  SimpleForm,
  TextInput,
  DateInput,
  NumberInput,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const JobList = ({ isEdit, isDelete }) => (
  <List
    filters={[
      <BooleanInput key="filter-isRecurring" source="isRecurring" />,
      <SelectInput
        key="filter-type"
        source="type"
        choices={[{ id: 'default', name: 'default' }]}
      />,
      <SelectInput
        key="filter-status"
        source="status"
        choices={[
          { id: 'pending', name: 'pending' },
          { id: 'processing', name: 'processing' },
          { id: 'completed', name: 'completed' },
          { id: 'error', name: 'error' },
        ]}
      />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? 'edit' : 'show'}>
      <DateField source="scheduledAt" />
      <BooleanField source="isRecurring" />
      <ChipField source="type" />
      <ChipField source="status" />
      <NumberField source="defaultIntervalInMinutes" />
      <TextField source="parameters" />
      <TextField source="error" />
    </Datagrid>
  </List>
)

export const JobEdit = () => (
  <Edit>
    <SimpleForm>
      <DateInput source="scheduledAt" />
      <NumberInput source="defaultIntervalInMinutes" />
    </SimpleForm>
  </Edit>
)

export const JobShow = () => (
  <Show>
    <SimpleShowLayout>
      <DateField source="scheduledAt" />
      <BooleanField source="isRecurring" />
      <ChipField source="type" />
      <ChipField source="status" />
      <NumberField source="defaultIntervalInMinutes" />
      <TextField source="parameters" />
      <TextField source="error" />
    </SimpleShowLayout>
  </Show>
)
